import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { useTheme } from '../../ThemeProvider';
import classes from './Input.styles.less';
export default function Input({ className, invalid = false, component: Element = 'input', ...others }) {
    const [theme] = useTheme();
    return (_jsx(Element, { className: cx(classes.input, classes[theme], { [classes.invalid]: invalid }, className), ...others }));
}
